

































































































































































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color } from "../../../../../../../base/domain/drawing";
import {
  LineStyleEditor,
  PaintStyleEditor,
} from "../../../../../../../base/components/drawing";
import { NumberInput } from "../../../../../../../base/components/system";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import {
  TimeStyleEditor,
  CheckBehaviorEditor,
  PrintBehaviorEditor,
  CopyLinkedCheckBehaviorEditor,
  FreeInputBehaviorEditor,
  QuoteBehaviorEditor,
  EditBehaviorEditor,
  TurnedTextStyleEditor,
  TooltipBehaviorEditor,
  NaturalTextBehaviorEditor,
  NumberStyleEditor,
  NumberRangeAlertBehaviorEditor,
  GroupAlertBehaviorEditor,
  EmptyAlertBehaviorEditor,
  LengthAlertBehaviorEditor,
  MultiLineBehaviorEditor,
  TextJoinBehaviorEditor,
  BookmarkEditor,
  BarcodeStyleEditor,
  LineGraphBehaviorEditor,
  TextSearchBehaviorEditor,
  ItemsStyleEditor,
  HisInformationItemDefaultSelectBehaviorEditor,
  ComboSelectBehaviorEditor,
  RollSelectBehaviorEditor,
  HospitalizedHisInformationItemDefaultSelectBehaviorEditor,
  ItemGroupSelectBehaviorEditor,
  FontSizeAutoAdjustBehaviorEditor,
  LineBreakBehaviorEditor,
  FocusBehaviorEditor,
  InputRuleBehaviorEditor,
  TextStyleEditor,
  ScriptExecuteBehaviorEditor,
  TableScriptExecuteBehaviorEditor,
  TableIndexPresenter,
  TableSizeEditor,
  ScriptGroupKeyEditor,
  DateStyleEditor,
  CheckStyleEditor,
  DateInputBehaviorEditor,
  BarcodeItemsEditor,
  PaintStyleOnEditingEditor,
  DesignatedDoctorInformationSourceEditor,
  InputMethodBehaviorEditor,
  UserDefinedItemSelectBehaviorEditor,
  DateCalculateBehaviorEditor,
  DateDurationExpressionBehaviorEditor,
  TimeSpanExpressionBehaviorEditor,
  PageExtendBehaviorEditor,
  ScriptExecuteTriggerBehaviorEditor,
  ScriptExecuteTriggerBehaviorEditorFromScriptlink,
  ItemSelectTriggerBehaviorEditor,
  ItemSelectTriggerBehaviorEditorFromUserDefined,
  TranscribeBehaviorEditor,
  EmptyAlertAllowBehaviorEditor,
  GroupAlertAllowBehaviorEditor,
  RangeOfMotionBehaviorEditor,
  TranscribeDateOfTimeBehaviorEditor,
  DecimalRoundBehaviorEditor,
  ​CopyLinkedTextBehaviorEditor,
  DateComparisonExpressionBehaviorEditor,
  CalculationExpressionBehaviorEditor,
  CalculationConditionalExpressionBehaviorEditor,
  ConditionalExpressionBehaviorEditor,
  QuestionnaireEditor,
} from "../../../../../../../documaker/components/format/objects/propertyEditors";
import { IConfiguration } from "../../../../../../domain/configuration";
import {
  FormatStructureEditorStoreReferableMixin,
  CommonComponentsAccessibleMixin,
} from "../../../mixins";
import {
  IdPropertyEditableMixin,
  NamePropertyEditableMixin,
  NameHistoriesPropertyEditableMixin,
  InformationKeyHistoriesPropertyEditableMixin,
  HisInformationKeyPropertyEditableMixin,
  UserDefinedInformationKeyPropertyEditableMixin,
  PrintBehaviorPropertyEditableMixin,
  LineStylePropertyEditableMixin,
  TextureStylePropertyEditableMixin,
  TimeStylePropertyEditableMixin,
  CheckBehaviorPropertyEditableMixin,
  ImageContentPropertyEditableMixin,
  CopyLinkedCheckBehaviorPropertyEditableMixin,
  MultiLineBehaviorPropertyEditableMixin,
  TextJoinBehaviorPropertyEditableMixin,
  BookmarkPropertyEditableMixin,
  FreeInputBehaviorPropertyEditableMixin,
  QuoteBehaviorPropertyEditableMixin,
  EditBehaviorPropertyEditableMixin,
  TurnedTextStylePropertyEditableMixin,
  TooltipBehaviorPropertyEditableMixin,
  NaturalTextBehaviorPropertyEditableMixin,
  NumberStylePropertyEditableMixin,
  NumberRangeAlertBehaviorPropertyEditableMixin,
  GroupAlertBehaviorPropertyEditableMixin,
  EmptyAlertBehaviorPropertyEditableMixin,
  LengthAlertBehaviorPropertyEditableMixin,
  CategoryNamePropertyEditableMixin,
  BarcodeStylePropertyEditableMixin,
  LineGraphBehaviorPropertyEditableMixin,
  TextSearchBehaviorPropertyEditableMixin,
  ItemsStylePropertyEditableMixin,
  CheckStylePropertyEditableMixin,
  HisInformationItemDefaultSelectBehaviorPropertyEditableMixin,
  DateStylePropertyEditableMixin,
  ComboSelectBehaviorPropertyEditableMixin,
  RollSelectBehaviorPropertyEditableMixin,
  HospitalizedHisInformationItemSelectBehaviorPropertyEditableMixin,
  ItemGroupSelectBehaviorPropertyEditableMixin,
  FontSizeAutoAdjustBehaviorEditorPropertyEditableMixin,
  LineBreakBehaviorEditorPropertyEditableMixin,
  FocusBehaviorPropertyEditableMixin,
  InputRuleBehaviorPropertyEditableMixin,
  TextStylePropertyEditableMixin,
  ScriptExecuteBehaviorPropertyEditableMixin,
  TableScriptExecuteBehaviorPropertyEditableMixin,
  TableIndexPropertyPresentableMixin,
  TableSizePropertyEditableMixin,
  ScriptGroupKeyPropertyEditableMixin,
  DateInputBehaviorPropertyEditableMixin,
  BarcodeItemPropertyEditableMixin,
  BarcodeCscanSetPropertyEditableMixin,
  PaintStyleOnEditingPropertyEditableMixin,
  DesignatedDoctorInformationSourcePropertyEditableMixin,
  InputMethodBehaviorPropertyEditableMixin,
  UserDefinedItemSelectBehaviorPropertyEditableMixin,
  DateCalculateBehaviorPropertyEditableMixin,
  DateDurationExpressionBehaviorPropertyEditableMixin,
  TimeSpanExpressionBehaviorPropertyEditableMixin,
  PageExtendBehaviorPropertyEditableMixin,
  ScriptExecuteTriggerBehaviorPropertyEditableMixin,
  ItemSelectTriggerBehaviorPropertyEditableMixin,
  TranscribeBehaviorEditorPropertyEditableMixin,
  EmptyAlertAllowBehaviorPropertyEditableMixin,
  GroupAlertAllowBehaviorPropertyEditableMixin,
  RangeOfMotionBehaviorPropertyEditableMixin,
  TranscribeDateOfTimeBehaviorPropertyEditableMixin,
  DecimalRoundBehaviorPropertyEditableMixin,
  CopyLinkedTextsBehaviorPropertyEditableMixin,
  DateComparisonExpressionBehaviorPropertyEditableMixin,
  CalculationExpressionBehaviorPropertyEditableMixin,
  ConditionalExpressionBehaviorPropertyEditableMixin,
  QuestionnairePropertyEditableMixin,
} from "../../../mixins/properties";
import { default as FormatObjectTemporaryImageUploader } from "../FormatObjectTemporaryImageUploader.vue";
@Component({
  components: {
    NumberInput,
    LineStyleEditor,
    PaintStyleEditor,
    TimeStyleEditor,
    CheckBehaviorEditor,
    PrintBehaviorEditor,
    FormatObjectTemporaryImageUploader,
    CopyLinkedCheckBehaviorEditor,
    MultiLineBehaviorEditor,
    TextJoinBehaviorEditor,
    BookmarkEditor,
    FreeInputBehaviorEditor,
    QuoteBehaviorEditor,
    EditBehaviorEditor,
    TurnedTextStyleEditor,
    TooltipBehaviorEditor,
    NaturalTextBehaviorEditor,
    NumberStyleEditor,
    NumberRangeAlertBehaviorEditor,
    GroupAlertBehaviorEditor,
    EmptyAlertBehaviorEditor,
    LengthAlertBehaviorEditor,
    BarcodeStyleEditor,
    LineGraphBehaviorEditor,
    TextSearchBehaviorEditor,
    ItemsStyleEditor,
    HisInformationItemDefaultSelectBehaviorEditor,
    ComboSelectBehaviorEditor,
    RollSelectBehaviorEditor,
    HospitalizedHisInformationItemDefaultSelectBehaviorEditor,
    ItemGroupSelectBehaviorEditor,
    FontSizeAutoAdjustBehaviorEditor,
    LineBreakBehaviorEditor,
    FocusBehaviorEditor,
    InputRuleBehaviorEditor,
    TextStyleEditor,
    ScriptExecuteBehaviorEditor,
    TableScriptExecuteBehaviorEditor,
    TableIndexPresenter,
    TableSizeEditor,
    ScriptGroupKeyEditor,
    DateStyleEditor,
    CheckStyleEditor,
    DateInputBehaviorEditor,
    BarcodeItemsEditor,
    PaintStyleOnEditingEditor,
    DesignatedDoctorInformationSourceEditor,
    InputMethodBehaviorEditor,
    UserDefinedItemSelectBehaviorEditor,
    DateCalculateBehaviorEditor,
    DateDurationExpressionBehaviorEditor,
    TimeSpanExpressionBehaviorEditor,
    PageExtendBehaviorEditor,
    ScriptExecuteTriggerBehaviorEditor,
    ScriptExecuteTriggerBehaviorEditorFromScriptlink,
    ItemSelectTriggerBehaviorEditor,
    ItemSelectTriggerBehaviorEditorFromUserDefined,
    TranscribeBehaviorEditor,
    EmptyAlertAllowBehaviorEditor,
    GroupAlertAllowBehaviorEditor,
    RangeOfMotionBehaviorEditor,
    TranscribeDateOfTimeBehaviorEditor,
    DecimalRoundBehaviorEditor,
    CopyLinkedTextBehaviorEditor,
    DateComparisonExpressionBehaviorEditor,
    CalculationExpressionBehaviorEditor,
    CalculationConditionalExpressionBehaviorEditor,
    ConditionalExpressionBehaviorEditor,
    QuestionnaireEditor,
  },
})
export default class FormatObjectPropertyEditor extends Mixins<
  ModelEditableMixin
  & FormatStructureEditorStoreReferableMixin
  & CommonComponentsAccessibleMixin
  & IdPropertyEditableMixin
  & NamePropertyEditableMixin
  & NameHistoriesPropertyEditableMixin
  & InformationKeyHistoriesPropertyEditableMixin
  & HisInformationKeyPropertyEditableMixin
  & UserDefinedInformationKeyPropertyEditableMixin
  & PrintBehaviorPropertyEditableMixin
  & LineStylePropertyEditableMixin
  & TextureStylePropertyEditableMixin
  & TimeStylePropertyEditableMixin
  & CheckBehaviorPropertyEditableMixin
  & ImageContentPropertyEditableMixin
  & CopyLinkedCheckBehaviorPropertyEditableMixin
  & MultiLineBehaviorPropertyEditableMixin
  & TextJoinBehaviorPropertyEditableMixin
  & BookmarkPropertyEditableMixin
  & FreeInputBehaviorPropertyEditableMixin
  & QuoteBehaviorPropertyEditableMixin
  & EditBehaviorPropertyEditableMixin
  & TurnedTextStylePropertyEditableMixin
  & TooltipBehaviorPropertyEditableMixin
  & NaturalTextBehaviorPropertyEditableMixin
  & NumberStylePropertyEditableMixin
  & NumberRangeAlertBehaviorPropertyEditableMixin
  & GroupAlertBehaviorPropertyEditableMixin
  & EmptyAlertBehaviorPropertyEditableMixin
  & LengthAlertBehaviorPropertyEditableMixin
  & CategoryNamePropertyEditableMixin
  & BarcodeStylePropertyEditableMixin
  & LineGraphBehaviorPropertyEditableMixin
  & TextSearchBehaviorPropertyEditableMixin
  & ItemsStylePropertyEditableMixin
  & CheckStylePropertyEditableMixin
  & HisInformationItemDefaultSelectBehaviorPropertyEditableMixin
  & DateStylePropertyEditableMixin
  & ComboSelectBehaviorPropertyEditableMixin
  & RollSelectBehaviorPropertyEditableMixin
  & HospitalizedHisInformationItemSelectBehaviorPropertyEditableMixin
  & ItemGroupSelectBehaviorPropertyEditableMixin
  & FontSizeAutoAdjustBehaviorEditorPropertyEditableMixin
  & LineBreakBehaviorEditorPropertyEditableMixin
  & FocusBehaviorPropertyEditableMixin
  & InputRuleBehaviorPropertyEditableMixin
  & TextStylePropertyEditableMixin
  & ScriptExecuteBehaviorPropertyEditableMixin
  & TableScriptExecuteBehaviorPropertyEditableMixin
  & TableIndexPropertyPresentableMixin
  & TableSizePropertyEditableMixin
  & ScriptGroupKeyPropertyEditableMixin
  & DateInputBehaviorPropertyEditableMixin
  & BarcodeItemPropertyEditableMixin
  & BarcodeCscanSetPropertyEditableMixin
  & PaintStyleOnEditingPropertyEditableMixin
  & DesignatedDoctorInformationSourcePropertyEditableMixin
  & InputMethodBehaviorPropertyEditableMixin
  & UserDefinedItemSelectBehaviorPropertyEditableMixin
  & DateCalculateBehaviorPropertyEditableMixin
  & DateDurationExpressionBehaviorPropertyEditableMixin
  & TimeSpanExpressionBehaviorPropertyEditableMixin
  & PageExtendBehaviorPropertyEditableMixin
  & ScriptExecuteTriggerBehaviorPropertyEditableMixin
  & ItemSelectTriggerBehaviorPropertyEditableMixin
  & TranscribeBehaviorEditorPropertyEditableMixin
  & EmptyAlertAllowBehaviorPropertyEditableMixin
  & GroupAlertAllowBehaviorPropertyEditableMixin
  & RangeOfMotionBehaviorPropertyEditableMixin
  & TranscribeDateOfTimeBehaviorPropertyEditableMixin
  & DecimalRoundBehaviorPropertyEditableMixin
  & CopyLinkedTextsBehaviorPropertyEditableMixin
  & DateComparisonExpressionBehaviorPropertyEditableMixin
  & CalculationExpressionBehaviorPropertyEditableMixin
  & ConditionalExpressionBehaviorPropertyEditableMixin
  & QuestionnairePropertyEditableMixin
>(
  ModelEditableMixin,
  FormatStructureEditorStoreReferableMixin,
  CommonComponentsAccessibleMixin,
  IdPropertyEditableMixin,
  NamePropertyEditableMixin,
  NameHistoriesPropertyEditableMixin,
  InformationKeyHistoriesPropertyEditableMixin,
  HisInformationKeyPropertyEditableMixin,
  UserDefinedInformationKeyPropertyEditableMixin,
  PrintBehaviorPropertyEditableMixin,
  LineStylePropertyEditableMixin,
  TextureStylePropertyEditableMixin,
  TimeStylePropertyEditableMixin,
  CheckBehaviorPropertyEditableMixin,
  ImageContentPropertyEditableMixin,
  CopyLinkedCheckBehaviorPropertyEditableMixin,
  MultiLineBehaviorPropertyEditableMixin,
  TextJoinBehaviorPropertyEditableMixin,
  BookmarkPropertyEditableMixin,
  FreeInputBehaviorPropertyEditableMixin,
  QuoteBehaviorPropertyEditableMixin,
  EditBehaviorPropertyEditableMixin,
  TurnedTextStylePropertyEditableMixin,
  TooltipBehaviorPropertyEditableMixin,
  NaturalTextBehaviorPropertyEditableMixin,
  NumberStylePropertyEditableMixin,
  NumberRangeAlertBehaviorPropertyEditableMixin,
  GroupAlertBehaviorPropertyEditableMixin,
  EmptyAlertBehaviorPropertyEditableMixin,
  LengthAlertBehaviorPropertyEditableMixin,
  CategoryNamePropertyEditableMixin,
  BarcodeStylePropertyEditableMixin,
  LineGraphBehaviorPropertyEditableMixin,
  TextSearchBehaviorPropertyEditableMixin,
  ItemsStylePropertyEditableMixin,
  CheckStylePropertyEditableMixin,
  HisInformationItemDefaultSelectBehaviorPropertyEditableMixin,
  DateStylePropertyEditableMixin,
  ComboSelectBehaviorPropertyEditableMixin,
  RollSelectBehaviorPropertyEditableMixin,
  HospitalizedHisInformationItemSelectBehaviorPropertyEditableMixin,
  ItemGroupSelectBehaviorPropertyEditableMixin,
  FontSizeAutoAdjustBehaviorEditorPropertyEditableMixin,
  LineBreakBehaviorEditorPropertyEditableMixin,
  FocusBehaviorPropertyEditableMixin,
  InputRuleBehaviorPropertyEditableMixin,
  TextStylePropertyEditableMixin,
  ScriptExecuteBehaviorPropertyEditableMixin,
  TableScriptExecuteBehaviorPropertyEditableMixin,
  TableIndexPropertyPresentableMixin,
  TableSizePropertyEditableMixin,
  ScriptGroupKeyPropertyEditableMixin,
  DateInputBehaviorPropertyEditableMixin,
  BarcodeItemPropertyEditableMixin,
  BarcodeCscanSetPropertyEditableMixin,
  PaintStyleOnEditingPropertyEditableMixin,
  DesignatedDoctorInformationSourcePropertyEditableMixin,
  InputMethodBehaviorPropertyEditableMixin,
  UserDefinedItemSelectBehaviorPropertyEditableMixin,
  DateCalculateBehaviorPropertyEditableMixin,
  DateDurationExpressionBehaviorPropertyEditableMixin,
  TimeSpanExpressionBehaviorPropertyEditableMixin,
  PageExtendBehaviorPropertyEditableMixin,
  ScriptExecuteTriggerBehaviorPropertyEditableMixin,
  ItemSelectTriggerBehaviorPropertyEditableMixin,
  TranscribeBehaviorEditorPropertyEditableMixin,
  EmptyAlertAllowBehaviorPropertyEditableMixin,
  GroupAlertAllowBehaviorPropertyEditableMixin,
  RangeOfMotionBehaviorPropertyEditableMixin,
  TranscribeDateOfTimeBehaviorPropertyEditableMixin,
  DecimalRoundBehaviorPropertyEditableMixin,
  CopyLinkedTextsBehaviorPropertyEditableMixin,
  DateComparisonExpressionBehaviorPropertyEditableMixin,
  CalculationExpressionBehaviorPropertyEditableMixin,
  ConditionalExpressionBehaviorPropertyEditableMixin,
  QuestionnairePropertyEditableMixin,
) {
  @Prop()
  pallet: Color[];

  $configuration!: IConfiguration;

  get configuration() {
    return this.$configuration.formatEditor.behavior.format.editor.object;
  }

  get typeName(): string {
    return this.readPropertyOrDefault(s => s.getTypeName(), "");
  }

  get isAlreadyLayouted(): boolean {
    return this.readPropertyOrDefault(s => s.isAlreadyLayouted(), false);
  }
}
